export function unsubscribe(subscriber: Subscriber, subscribed: Subscriber[]): any {
  return subscribed.filter((subscribedOne: Subscriber) => subscribedOne.name !== subscriber.name);
}
